$mol_view_tree2_to_js_test_ex_simple_typed_null_foo $mol_object
	a null string|number
